import { Stack, Skeleton as MuiSkeleton } from '@mui/material';

export const Skeleton = () => {
  return (
    <Stack spacing={2} mt={2}>
      <MuiSkeleton height={160} variant="rounded" width="100%" />
      <MuiSkeleton height={180} variant="rounded" width="100%" />
      <MuiSkeleton height={160} variant="rounded" width="100%" />
    </Stack>
  );
};
